module.exports = __webpack_public_path__ + "static/img/PatCummins.6f4e233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PatCummins.jpg
// module id = wN+6
// module chunks = 0